import { ColumnPlainObject, ColumnType, ColumnDecimalType, ColumnComplexType, ColumnArrayType, ColumnMapType, ColumnExternalType } from '../plainObjects/column.plainObject';

export class SchemaUtil {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getSchemaFromInputOutputDefinition(inputOutputDefinitionContext: any): ColumnPlainObject[] {
        const schema: ColumnPlainObject[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inputOutputDefinitionContext.columnDefinition().forEach((columnDefinition: any) => {
            const columnInformation: ColumnPlainObject = SchemaUtil._getColumnInformation(columnDefinition);
            schema.push(columnInformation);
        });
        return schema;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getColumnName(columnIdentifier: any): string {
        let columnName = '';
        if (columnIdentifier.basicName()) {
            columnName = columnIdentifier.getText();
        } else if (columnIdentifier.anyName()) {
            const anyIdentifier = columnIdentifier.anyName().ANY_IDENTIFIER();
            if (anyIdentifier) {
                const identifierText = anyIdentifier.getText();
                columnName = SchemaUtil.removeWrappingCharacters(identifierText);
            } else {
                columnName = columnIdentifier.anyName().keyWord().getText();
            }
        }
        return columnName;
    }

    public static removeWrappingCharacters(columnName: string): string {
        return columnName.substring(1, columnName.length - 1);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static _getColumnDataType(dataType: any): ColumnType {
        let columnType: ColumnType;
        if (dataType.simple) {
            if (dataType.simple().DECIMAL) {
                columnType = new ColumnDecimalType();
                (columnType as ColumnDecimalType).precision = parseInt(dataType.simple().precision.getText(), 10);
                (columnType as ColumnDecimalType).scale = parseInt(dataType.simple().scale.getText(), 10);
            } else {
                columnType = new ColumnType(dataType.simple().getText());
            }
        } else if (dataType.complex) {
            const complexDataFlowType = new ColumnComplexType();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dataType.complex().columnDefinition().forEach((nestedColumnDefinition: any) => {
                const nestedcolumn = SchemaUtil._getColumnInformation(nestedColumnDefinition);
                complexDataFlowType.fields.push(nestedcolumn);
            });
            columnType = complexDataFlowType;
        } else if (dataType.OPEN_CLOSE_SQ) {
            const arraycolumn = new ColumnArrayType();
            arraycolumn.arrayType = SchemaUtil._getColumnDataType(dataType.datatype());
            columnType = arraycolumn;
        } else if (dataType.mapKey && dataType.mapValue) {
            const mapColumn = new ColumnMapType();
            mapColumn.keyType = SchemaUtil._getColumnDataType(dataType.mapKey);
            mapColumn.valueType = SchemaUtil._getColumnDataType(dataType.mapValue);
            columnType = mapColumn;
        }

        return columnType;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static _getColumnInformation(columnDefinition: any): ColumnPlainObject {
        const columnInformation: ColumnPlainObject = new ColumnPlainObject();
        columnInformation.name = SchemaUtil.getColumnName(columnDefinition.columnIdentifier());
        columnInformation.columnType = new ColumnType('string');

        if (columnDefinition.inlineDatatype()) {
            const columnType = SchemaUtil._getColumnDataType(columnDefinition.inlineDatatype().datatype());
            columnInformation.columnType = columnType || columnInformation.columnType;

            if (columnDefinition.inlineDatatype() && columnDefinition.inlineDatatype().dataFormat()) {
                let format = columnDefinition.inlineDatatype().dataFormat().getText() as string;
                if (format.startsWith('[')) {
                    format = SchemaUtil.removeWrappingCharacters(format);
                    format = format.indexOf(',') > -1 ? format.split(',')[0] : format;
                }
                columnInformation.columnType.format = SchemaUtil.removeWrappingCharacters(format);
            }
        } else if (columnDefinition.externalDatatype()) {
            const columnType = new ColumnExternalType();
            if (columnDefinition.externalDatatype() && columnDefinition.externalDatatype().expression()) {
                const expression = columnDefinition.externalDatatype().expression().getText() as string;
                columnType.expression = expression;
                columnInformation.columnType = columnType || columnInformation.columnType;
            }
        }
        return columnInformation;
    }
}
